import { IconButton } from "@material-ui/core";
import NightsStayIcon from "@material-ui/icons/NightsStay";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import * as React from "react";
import { THEME } from "../../theme/ThemeStore";

export const DarkModeToggle = () => {
    return (
        <IconButton
            onClick={() => {
                THEME.toggleMode();
            }}
        >
            {THEME.THEME_MODE === "dark" ? <WbSunnyIcon /> : <NightsStayIcon />}
        </IconButton>
    );
};
